var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",style:(_vm.finallyStyle+_vm.shapeStyle)},[_c('div',{staticClass:"content",style:(_vm.textStyle)},[_c('div',{domProps:{"textContent":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }